import { render, staticRenderFns } from "./Consultants.vue?vue&type=template&id=a808bdee&scoped=true&"
import script from "./Consultants.vue?vue&type=script&lang=ts&"
export * from "./Consultants.vue?vue&type=script&lang=ts&"
import style0 from "./Consultants.vue?vue&type=style&index=0&id=a808bdee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a808bdee",
  null
  
)

export default component.exports